import { decode } from 'qss';
import { isSSR } from './isSSR.js';

var getDefaultHasStatusBar = function getDefaultHasStatusBar() {
  if (isSSR()) {
    return undefined;
  }

  var query = decode(window.location.search);
  return query.should_full_screen === 1;
};

export { getDefaultHasStatusBar };
//# sourceMappingURL=statusBar.js.map
